import React, { useState, useEffect } from 'react'
import { Box, Flex, Select, Group, Button, TextInput, Loader, Text, Avatar } from '@mantine/core'
import { getListUsers } from '../../../services/users'
import { useDebouncedCallback } from '@mantine/hooks'
import { IconCheck } from '@tabler/icons-react'

const defaultParams = {
  'page[num]': 1,
  'page[limit]': 10,
  'filter[request_number][is]': null,
  'filter[user_id][is]': null,
  'filter[agent_id][is]': null,
  'filter[statuses.id][is]': null
}

const defaultStatus = [
  {
    value: '82',
    label: 'In Review'
  },
  {
    value: '83',
    label: 'In Progress'
  },
  {
    value: '84',
    label: 'Finished'
  },
  {
    value: '85',
    label: 'Canceled'
  },
]

const FormFilterRequest = ({ paramsRequest, applyFilter, onClose }) => {
  const [parameter, setParameter] = useState(defaultParams)
  const [userList, setUserList] = useState([])
  const [agentList, setAgentList] = useState([])
  const [loadingUser, setLoadingUser] = useState(true)
  const [loadingAgent, setLoadingAgent] = useState(true)
  const [searchUser, setSearchUser] = useState('')
  const [searchAgent, setSearchAgent] = useState('')

  const handleGetListUsers = useDebouncedCallback(async (userId) => {
    setLoadingUser(true)
    const parameter = {
      'filter[id][is]': userId,
      'filter[name][like]': searchUser,
      'fields[user]': 'id,name,email,active',
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'active': true
    }
    try {
      const response = await getListUsers(parameter)
      const dataUser = response.data.data
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email
        }
      })
      setUserList(remapDataUser)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingUser(false)
    }
  }, 300)

  const handleGetListAgent = useDebouncedCallback(async (userId) => {
    setLoadingAgent(true)
    const parameter = {
      'filter[id][is]': userId,
      'filter[name][like]': searchAgent,
      'fields[user]': 'id,name,email,active',
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'active': true,
      'filter[is_agent][is]': 1,

    }
    try {
      const response = await getListUsers(parameter)
      const dataUser = response.data.data
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email
        }
      })
      setAgentList(remapDataUser)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingAgent(false)
    }
  }, 300)

  useEffect(() => {
    handleGetListUsers()
    // eslint-disable-next-line
  }, [searchUser])

  useEffect(() => {
    handleGetListAgent()
    // eslint-disable-next-line
  }, [searchAgent])

  useEffect(() => {
    if (paramsRequest !== null) {
      if (paramsRequest[`filter[user_id][is]`]) {
        handleGetListUsers(paramsRequest[`filter[user_id][is]`])
      }
      if (paramsRequest[`filter[agent_id][is]`]) {
        handleGetListAgent(paramsRequest[`filter[user_id][is]`])
      }
      handleSetParams(paramsRequest)
    }
    // eslint-disable-next-line
  }, [paramsRequest])

  const handleSetParams = (val) => {
    const prevParams = {
      'filter[request_number][is]': val['filter[request_number][is]'],
      'filter[user_id][is]': val[`filter[user_id][is]`],
      'filter[agent_id][is]': val['filter[agent_id][is]'],
      'filter[statuses.id][is]': val['filter[statuses.id][is]']
    }
    setParameter(prevParams)
  }

  const handleChangeFilter = (name, val) => {
    setParameter((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleApplyFilter = (params) => {
    const valueParams = {
      ...params,
      'page[num]': 1,
      'page[limit]': 10,
      'filter[request_number][is]': params['filter[request_number][is]'] === '' ? null : params['filter[request_number][is]']
    }
    applyFilter(valueParams)
    onClose()
  }

  const loadingDataUser = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  const renderUserOption = ({ option, checked }) => {
    return (
      <Group flex="1" align='center' gap="xs">
        <Flex gap='sm' align='center'>
          <Avatar variant='filled' name={option.label} radius="xl" size="sm" color='red' />
          <Box>
            <Text fz={12} fw='600' lineClamp={2}>{option.label}</Text>
            <Text fz={10} fw='500' c='gray.6' lineClamp={2}>{option.email}</Text>
          </Box>
        </Flex>
        {checked && <IconCheck style={{ marginInlineStart: 'auto' }} />}
      </Group>
    )
  }

  return (
    <Box>
      <Box mb='md'>
        <TextInput
          name='filter[request_number][is]'
          value={parameter['filter[request_number][is]']}
          label='Request Number'
          placeholder='Input request number'
          onChange={(val) => handleChangeFilter('filter[request_number][is]', val.target.value)}
          size='xs'
        />
      </Box>
      <Box mb='md'>
        <Select
          name='filter[user_id][is]'
          value={parameter['filter[user_id][is]']}
          label='Select User'
          data={userList}
          renderOption={renderUserOption}
          onChange={(val) => handleChangeFilter('filter[user_id][is]', val)}
          size='xs'
          searchable
          searchValue={searchUser}
          onSearchChange={setSearchUser}
          nothingFoundMessage={!loadingUser ? userList.length > 0 ? '' : 'No User Found' : loadingDataUser()}
          clearable
          withAsterisk
        />
      </Box>
      <Box mb='md'>
        <Select
          name='filter[agent_id][is]:'
          value={parameter['filter[agent_id][is]:']}
          label='Select Agent'
          data={agentList}
          renderOption={renderUserOption}
          onChange={(val) => handleChangeFilter('filter[agent_id][is]:', val)}
          size='xs'
          searchable
          searchValue={searchAgent}
          onSearchChange={setSearchAgent}
          nothingFoundMessage={!loadingAgent ? agentList.length > 0 ? '' : 'No Agent Found' : loadingDataUser()}
          clearable
        />
      </Box>
      <Box mb='md'>
        <Select
          name='filter[statuses.id][is]'
          value={parameter['filter[statuses.id][is]']}
          label='Select Status'
          data={defaultStatus}
          onChange={(val) => handleChangeFilter('filter[statuses.id][is]', val)}
          size='xs'
          clearable
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onClose}>Close</Button>
            <Button size='xs' variant="filled" onClick={() => handleApplyFilter(parameter)}>Apply Filter</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormFilterRequest